import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, map, throwError } from 'rxjs';
import { SelfServiceEmailInvite, SelfServiceEmailTemplate } from './self-service-email.interface';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceEmailService {

  constructor(private _http: HttpClient) { }

  public searchInviteHistory(payload: any) {
    return this._http.post<SelfServiceEmailInvite[]>((environment.api) + 'SelfServiceEmailControl/search', payload)
      .pipe(
        catchError(error => throwError(() => error)),
        map((inviteHistory) => {
          // Transform date/times from string to Date type
          return inviteHistory;
        })
      );
  }

  public sendEmailInvite(payload: any) {
    return this._http.post((environment.api) + 'SelfServiceEmailControl/send', payload)
      .pipe(
        catchError(error => throwError(() => error)),
      );
  }

  public getEmailTemplates() {
    return this._http.get<SelfServiceEmailTemplate[]>((environment.api) + 'SelfServiceEmailControl/templates')
      .pipe(
        catchError(error => throwError(() => error)),
      );
  }

}
